<template>
  <div class="navbar">
    <div
      class="hamburger-container"
      style="padding: 0 15px"
      @click="toggleSideBar()"
    >
      <i
        :class="{
          'el-icon-s-fold': sidebar.opened,
          'el-icon-s-unfold': !sidebar.opened,
        }"
        style="font-size: 25px; margin-top: 13px"
      />
    </div>
    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span v-if="info.weChatUser !== undefined">
            <img
              :src="info.weChatUser.headImage"
              alt=""
              style="vertical-align: middle"
            />
          </span>
          <span>
            {{ info.name }}
          </span>

          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item>
            <div @click="bind">个人信息</div>
          </el-dropdown-item>

          <el-dropdown-item>
            <div @click="editDialog = true">修改密码</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="logout">退出登录</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="editDialog"
      title="修改密码"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        label-width="auto"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="editForm.phone"
            maxlength="11"
            placeholder="请输手机号"
          />
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input v-model="editForm.code" placeholder="验证码">
            <template slot="append">
              <div @click="send">发送验证码</div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="修改密码" prop="pwd1">
          <el-input
            v-model="editForm.pwd1"
            placeholder="请输密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="密码确认" prop="pwd2">
          <el-input
            v-model="editForm.pwd2"
            placeholder="密码确认"
            show-password
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editPost">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb/index";
import logout from "@/api/login/logout";
import agentChangePwd from "@/api/user/agent-manage/agentChangePwd";
import resDispose from "@/mixin/resDisposeMixin";
import dialogMixin from "@/mixin/dialogMixin";
import sendMsgByPhone from "@/api/common/short-msg/sendMsgByPhone";
import { checkPhone } from "@/utils/check";

export default {
  components: { Breadcrumb },
  mixins: [resDispose, dialogMixin],
  computed: {
    ...mapGetters(["sidebar", "device", "info"]),
  },
  data() {
    return {
      editDialog: false,
      editForm: {
        phone: undefined,
        code: undefined,
        pwd1: undefined,
        pwd2: undefined,
      },
      rules: {
        phone: checkPhone,
        code: [{ required: true, message: "请输入验证码" }],
        pwd1: [
          { required: true, message: "请输入密码" },
          { min: 6, max: 20, message: "长度在6到20个字符" },
        ],
        pwd2: {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请再次输入密码"));
            } else if (value !== this.editForm.pwd1) {
              callback(new Error("两次输入密码不一致!"));
            } else {
              callback();
            }
          },
        },
      },
    };
  },
  methods: {
    bind() {
      this.$router.push({ name: "个人信息" });
    },
    send() {
      sendMsgByPhone({
        phone: this.editForm.phone,
        msgType: "agentChangePwd",
      }).then((res) => {
        this.resDispose({ res });
      });
    },
    editPost() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          agentChangePwd({
            code: this.editForm.code,
            pwd: this.editForm.pwd1,
          }).then((res) => {
            this.resDispose({
              res,
              success: () => {
                this.editDialog = false;
              },
            });
          });
        }
      });
    },
    ...mapActions({
      logout_login: "logout",
    }),
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    logout() {
      logout().then((res) => {
        this.resDispose({
          res,
          success: () => {
            this.logout_login();
            this.$router.push(`/login`);
          },
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        display: inline-block;
        // margin-top: 5px;
        position: relative;
        cursor: pointer;

        img {
          width: 30px;
          height: 30px;
        }

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          // top: 25px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 12px;
        }
      }
    }
  }
}
</style>
